<template>
  <component :is="`planned-transaction-view-${layout}`"
             :transaction="transaction"
             :display-time="displayTime"
             :display-contractor="displayContractor"
             :apply-opacity="applyOpacity"
             @confirm="$emit('confirm', transaction.id)"
             @remove="$emit('remove', transaction.id)"
             @edit="$emit('edit', transaction)"/>
</template>

<script>
import PlannedTransactionViewCalendar
  from "@/components/common/PlannedTransaction/PlannedTransactionView/PlannedTransactionViewCalendar";
import PlannedTransactionViewDefault
  from "@/components/common/PlannedTransaction/PlannedTransactionView/PlannedTransactionViewDefault";
import PlannedTransactionViewCompact
  from "@/components/common/PlannedTransaction/PlannedTransactionView/PlannedTransactionViewCompact";

export default {
  name: "PlannedTransactionItem",
  components: {PlannedTransactionViewCompact, PlannedTransactionViewDefault, PlannedTransactionViewCalendar},
  props: {
    layout: {
      type: String,
      default: 'default',
      validator: (value) => ['calendar', 'compact', 'default'].includes(value)
    },
    transaction: {
      type: Object,
      required: true
    },
    applyOpacity: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    displayTime() {
      return this.$store.getters["space/spaceTimeEnabled"];
    },
    displayContractor() {
      return this.$store.getters["space/spaceUseContractors"];
    }
  }
}
</script>

<style scoped>

</style>